module.exports = __webpack_public_path__ + "static/media/Students.1e82731e.png";